import React from 'react';

import { ArrowDropUpIcon, ArrowDropDownIcon } from '@gogame/ui/Icon';
import ListItem from '@gogame/ui/ListItem';
import ListItemIcon from '@gogame/ui/ListItemIcon';
import ListItemSecondaryAction from '@gogame/ui/ListItemSecondaryAction';
import ListItemText from '@gogame/ui/ListItemText';
import Stack from '@gogame/ui/Stack';
import Prefix from './Prefix';
import Typography from '@gogame/ui/Typography';
import Checkbox from '@gogame/ui/Checkbox';

export const dataCy = 'virtualized-list-subheader';

export const dataCyTitle = 'virtualized-list-row-title';
export const dataCyAction = 'virtualized-list-row-action';
export const dataCyActionCheckbox = 'virtualized-list-row-action-checkbox';

const BaseListSubheader = ({
  // rowHeight,
  primaryLabel,
  primaryTooltip,
  actionCount,
  groupAction,
  icon,
  checkbox,
  // checked,
  secondaryLabel,
  secondaryTooltip,

  // isAllChecked,
  // count,
  button,
  selected,
  indeterminate,
  // state = { expanded: false },
  // style: { marginLeft, ...style },
  style,
  onChange,
  onClick,
  // gutterLabel,
  divider,
  // labelWrap  = true,
  // isTreeData,
  className,
  disabled,
  childrenCount,
  expanded = true,
  sticky,
  position,
  height,
  holder,
}) => {
  return (
    <ListItem
      // ref={ref}
      component={'div'}
      button={true}
      disabled={disabled}
      divider={true}
      selected={selected}
      ContainerComponent={'div'}
      // onClick={groupItem ? onChange : !disabled ? onItemClick : null}
      actionCount={actionCount}
      onClick={onClick}
      ContainerProps={{
        style: {
          height: '100%',
        },
      }}
      style={{
        ...style,
        height: '100%',
        boxSizing: 'border-box',
      }}
      data-cy={dataCy}
    >
      {icon ? (
        <Prefix>
          <ListItemIcon>{icon}</ListItemIcon>
        </Prefix>
      ) : null}
      {checkbox ? (
        <ListItemIcon>
          <Checkbox
            edge={'start'}
            checked={selected}
            indeterminate={indeterminate}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              if (onChange) {
                e.stopPropagation();
                onChange(e);
              }
            }}
            tabIndex={-1}
            // checkedIcon={
            //   <CheckBoxIcon sx={{ fontSize: 20 }} />
            // }
            disableRipple
            disabled={disabled}
            data-cy-action={dataCyActionCheckbox}
          />
        </ListItemIcon>
      ) : null}

      <ListItemText
        disableTypography={true}
        primary={
          <Stack direction={'row'} spacing={1} alignItems={'center'} flex={1}>
            <Typography
              style={{
                fontWeight: 500,
              }}
              data-cy={dataCyTitle}
              noWrap={true}
              variant={'body1'}
              tooltipText={primaryTooltip}
            >
              {primaryLabel}
            </Typography>
            {childrenCount ? (
              expanded ? (
                <ArrowDropUpIcon />
              ) : (
                <ArrowDropDownIcon />
              )
            ) : null}
          </Stack>
        }
      />
      {groupAction ? (
        <ListItemSecondaryAction data-cy={dataCyAction}>
          {groupAction}
        </ListItemSecondaryAction>
      ) : null}
    </ListItem>
  );
};

export default BaseListSubheader;
